import styled from "styled-components";

export const SNotes = styled.div`
  display: flex;
  flex-direction: column;

  button {
    margin-left: 0.5rem !important;
  }
`;

export const SNoteList = styled.div`
  display: flex;
  flex-direction: column;
  height: 84%;
  margin: 0.5rem 0.5rem;
  font-size: 1.2rem;
`;

export const SNote = styled.div`
  display: flex;
  flex-direction: column;

  .name {
    font-weight: bold;
    color: var(--text-primary-light);
  }

  i {
    cursor: pointer;
    color: var(--text-primary-light);
  }
`;

export const STextEditor = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 0.5rem;
  overflow-x: hidden;
  margin-top: 0.7rem;
  margin-bottom: 1rem;
  height: 100%;

  .ck-editor__editable:not(.ck-editor__nested-editable) {
    min-height: 80vh;
  }

  .btn-section {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .btn-section button {
    margin-top: 0.7rem !important;
    margin-right: 0.3rem;
    padding: 0.3 0.3rem 0.3 0.3rem !important;
    width: 100%;
  }
`;
